module.exports = __webpack_public_path__ + "img/moneychannel.56600f34.png";